module.exports = __webpack_public_path__ + "static/media/logoJAVASCRIPT.ada0e754.svg";